import React from "react";

// Page-wide safety net. Without this, ANY render error or failed lazy page-chunk load unmounts the whole
// React tree and the shopper sees a permanently white screen (reported after checkout and on slow phones).
// - A failed dynamic import (stale chunk after a deploy / flaky in-app browser) reloads the page ONCE automatically.
// - Anything else shows a "Tap to reload" screen instead of white. Login (localStorage) is never touched.
const CHUNK_RE = /dynamically imported module|Importing a module script failed|Loading chunk|Loading CSS chunk|error loading dynamically/i;
const KEY = "bloom:chunk-reload-at";

export function isChunkError(err) {
  const m = String((err && (err.message || err)) || "");
  return CHUNK_RE.test(m);
}

// Reload once per 30s at most, so a genuinely broken chunk can't cause a reload loop.
export function reloadOnceForChunk() {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 30000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* storage blocked — still try once */ }
  window.location.reload();
  return true;
}

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err) {
    try { console.error("ErrorBoundary:", err); } catch { /* ignore */ }
    if (isChunkError(err)) reloadOnceForChunk();
  }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:14,padding:"0 24px",textAlign:"center",background:"#fff",color:"#14171f",fontFamily:"system-ui,-apple-system,sans-serif"}}>
        <div style={{fontSize:22,fontWeight:700}}>Something went wrong loading this page</div>
        <div style={{fontSize:14,opacity:0.65,maxWidth:320,lineHeight:1.5}}>Your cart and login are safe. Tap below to reload.</div>
        <button onClick={() => window.location.reload()} style={{padding:"12px 28px",fontSize:15,fontWeight:700,background:"#14171f",color:"#fff",border:"none",borderRadius:4,cursor:"pointer"}}>Reload</button>
        <a href="/" style={{fontSize:13,color:"#14171f",opacity:0.7}}>Go to home</a>
      </div>
    );
  }
}
